import React, { Suspense } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ErrorBoundary } from './ui';
import { useAuth } from '../contexts/AuthContext';
import { isAdminSite } from '../utils/adminSite';
import './SuperAdminLayout.css';

// Super admins work for Run The Club, not a club: their own frame, with none
// of a club's branding, menus or banners. Anyone else is sent to their club.
export default function SuperAdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onAdminSite = isAdminSite();
  if (loading) return <div className="loading"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'SUPER_ADMIN') {
    if (!onAdminSite) return <Navigate to="/dashboard" replace />;
    return (
      <div className="rtc-shell">
        <div className="rtc-denied">
          <h1>This site is for Run The Club staff</h1>
          <p>You're signed in as {user.email}, which belongs to a club. Sign in on your club's own site instead.</p>
          <button type="button" className="rtc-bar__out rtc-denied__out" onClick={() => { logout(); navigate('/login'); }}>Sign out</button>
        </div>
      </div>
    );
  }

  if (onAdminSite) document.title = 'Run The Club admin';
  return (
    <div className="rtc-shell">
      <header className="rtc-bar">
        <span className="rtc-bar__brand">Run The Club <span className="rtc-bar__tag">Super admin</span></span>
        <span className="rtc-bar__me">
          <span className="rtc-bar__email">{user.email}</span>
          <button type="button" className="rtc-bar__out" onClick={() => { logout(); navigate('/login'); }}>Sign out</button>
        </span>
      </header>
      <main>
        <ErrorBoundary key={pathname}>
          <Suspense fallback={<div className="loading"><div className="spinner" /></div>}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
    </div>
  );
}
